module.exports = __webpack_public_path__ + "exo-latin-900.6eb1c493737303a66b1b.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-900.svg
// module id = ../../../../typeface-exo/files/exo-latin-900.svg
// module chunks = styles